/*
 * @Author: your name
 * @Date: 2020-06-29 09:34:55
 * @LastEditTime: 2020-08-26 09:56:44
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \Parts_APP\src\api\maintain.js
 */
import request from '@/utils/request'
// 获取入场记录
export const getrecordlist = (data) => request({
    url: process.env.VUE_APP_MT_API + '/entrance/list',
    method: 'POST',
    data
})

// 提交入场记录
export const submitRecord = (data) => request({
    url: process.env.VUE_APP_MT_API + '/entrance/submit',
    method: 'POST',
    data
})
// 入场检查派工确认
export const submitRecords = (data) => request({
    url: process.env.VUE_APP_MT_API + '/entrance/submitWorkOrder',
    method: 'POST',
    data
})
// 入场出场
export const entranceOrExit = (data) => request({
    url: process.env.VUE_APP_MT_API + '/entrance/record',
    method: 'POST',
    data
})

// 获取待保养设备列表
export const getToMaintainList = (data) => request({
    url: process.env.VUE_APP_MT_API + '/tobemt/list',
    method: 'POST',
    data
})
// 关闭待保养设备
export const closeToMaintain = (id) => request({
    url: process.env.VUE_APP_MT_API + '/tobemt/close?id=' + id,
    method: 'POST'
})
// 获取质检列表
export const getQualityCheckList = (data) => request({
    url: process.env.VUE_APP_MT_API + '/qc/list',
    method: 'POST',
    data
})

// 获取质检详细
export const getQualityCheckItem = (data) => request({
    url: process.env.VUE_APP_MT_API + '/qc/item?id=' + data,
    method: 'POST'
})

// 质检提交
export const qualityCheckSubmit = (data) => request({
    url: process.env.VUE_APP_MT_API + '/qc/submit',
    method: 'POST',
    data
})
// 质检确认
export const qualityCheckSubmits = (data) => request({
    url: process.env.VUE_APP_MT_API + '/WorkOrder/updateConfirm',
    method: 'POST',
    data
})
// 获取结算单列表
export const getStatementList = (data) => request({
    url: process.env.VUE_APP_MT_API + '/Statement/list',
    method: 'POST',
    data
})

// 获取结算单列表-获取车辆类别
export const getStatemenTypetList = (data) => request({
    url: process.env.VUE_APP_BASIC_API + '/DataDictionary/getdictionaryddl?Code=Other:VehicleType',
    method: 'GET',
    data
})

// 获取派工单列表
export const getWorkOrderList = (data) => request({
    url: process.env.VUE_APP_MT_API + '/workOrder/list',
    method: 'POST',
    data
})
// 获取字典数据，部位(Maintain:PositionsType)、车辆类别(Other:VehicleType)、品牌(Other:VehicleBrand)、
export const getStateDDl = (type) => request({
    url: process.env.VUE_APP_BASIC_API + '/DataDictionary/getdictionaryddl?Code=' + type,
    method: 'get'
})
// 获取司机列表
export const getDriverlist = (data) => request({
    url: process.env.VUE_APP_BASIC_API + '/driver/list',
    method: 'POST',
    data
})

// 获取部件
export const getVehiclePostn = (data) => request({
    url: process.env.VUE_APP_BASIC_API + '/vehicleposit/getListByPage',
    method: 'POST',
    data
})
// 获取保养\缺件继续维修提醒
export const getReminder = (data, vid) => request({
    url: process.env.VUE_APP_MT_API + '/display/reminder?vehicleId=' + vid,
    method: 'POST',
    data
})
// 获取视图配置
export const getSystemConfig = (orgid) => request({
    url: process.env.VUE_APP_BASIC_API + '/SystemConfig/viewconfig?OrgId=' + orgid,
    method: 'GET'

})
// 获取结算单详情
export const getStateDetail = (sid) => request({
    url: process.env.VUE_APP_MT_API + '/Statement/' + sid,
    method: 'GET'

})
// 结算单提交
export const PostStateDetail = (data) => request({
    url: process.env.VUE_APP_MT_API + '/Statement/confirm',
    method: 'POST',
    data

})
// 结算单上传签字图片
export const PostSign = (data) => request({
    url: process.env.VUE_APP_ATTA + '/upload/uploadWithMeta',
    method: 'POST',
    data,
    responseType: 'arraybuffer',
    timeout: null
})
// 附件上传
export function uploadAnnex(data) {
    return request({
        url: process.env.VUE_APP_ATTA + '/upload/uploadWithMeta',
        method: 'POST',
        data
    })
}
// 签字图片
export const getSign = (id) => request({
    url: process.env.VUE_APP_IMG + '/file/' + id,
    method: 'get',
    responseType: 'arraybuffer',
    timeout: null
})

// 获取结算单详情
export const getVehicleInfo = (vid) => request({
    url: process.env.VUE_APP_MT_API + '/entrance/queryitem?id=' + vid,
    method: 'POST'

})

// 派工单详情
export function getWorkOrder(id) {
    return request({
        url: process.env.VUE_APP_MT_API + '/WorkOrder/' + id,
        method: 'get'
    })
}
// 获取维修项目列表
export const getWorkOrderitemList = (data) => request({
    url: process.env.VUE_APP_MT_API + '/WorkOrder/itemList',
    method: 'POST',
    data
})
// 待保养提醒
export function displayreminder(vechicleid) {
    return request({
        url: process.env.VUE_APP_MT_API + `/display/reminder?vehicleId=${vechicleid}`,
        method: 'post'
    })
}
// 维修队实况列表
export function displayteam(id) {
    return request({
        url: process.env.VUE_APP_MT_API + '/display/team?maintainItemId=' + id,
        method: 'post'
    })
}
// 根据项目id获取维修队
export function GetworkerByMtId(data) {
    return request({
        url: process.env.VUE_APP_BASIC_API + '/mtWorker/GetworkerByMtId',
        method: 'post',
        data
    })
}
// 派工单暂存
export function WorkOrdertempSave(data) {
    return request({
        url: process.env.VUE_APP_MT_API + '/WorkOrder/tempSave',
        method: 'post',
        data
    })
}

// 待修故障列表
export function WorkOrderawmList(data) {
    return request({
        url: process.env.VUE_APP_MT_API + '/WorkOrder/awmList',
        method: 'post',
        data
    })
}
// 待修故障列表派工
export function awmFaultprocess(data) {
    return request({
        url: process.env.VUE_APP_MT_API + '/WorkOrder/awmFault/process',
        method: 'post',
        data
    })
}
// 派工调度列表
export function dispatchList(data) {
    return request({
        url: process.env.VUE_APP_MT_API + '/WorkOrder/list',
        method: 'post',
        data
    })
}
// 派工单提2
export function WorkOrdercommits(data) {
    return request({
        url: process.env.VUE_APP_MT_API + '/WorkOrder/checkWorkOrder',
        method: 'post',
        data
    })
}
// 派工单提交
export function WorkOrdercommit(data) {
    return request({
        url: process.env.VUE_APP_MT_API + '/WorkOrder/commit',
        method: 'post',
        data
    })
}
// 派工单提交质检
export function WorkOrdercommitQC(data) {
    return request({
        url: process.env.VUE_APP_MT_API + '/WorkOrder/commitQC',
        method: 'post',
        data
    })
}
// 维修项目历史记录
export function WorkOrderhistoryList(data) {
    return request({
        url: process.env.VUE_APP_MT_API + '/WorkOrder/historyList',
        method: 'post',
        data
    })
}
// 返修派工单详情
export function getrepair(id) {
    return request({
        url: process.env.VUE_APP_MT_API + '/WorkOrder/repair/' + id,
        method: 'get'
    })
}
// 入场车辆详情
export function entrancequery(id) {
    return request({
        url: process.env.VUE_APP_MT_API + '/entrance/queryitem?id=' + id,
        method: 'post'
    })
}
// 待保养提醒
export function displaycancle(data) {
    return request({
        url: process.env.VUE_APP_MT_API + `/display/cancle`,
        method: 'post',
        data
    })
}
// 缺件提醒确定
export function displaymplist(id) {
    return request({
        url: process.env.VUE_APP_MT_API + `/display/mplist?vehicleId=` + id,
        method: 'post'
    })
}
// 派工查看（维修队）添加项目
// export function workOrderDispatch(data) {
//     return request({
//         url: process.env.VUE_APP_MT_API + '/workOrder/dispatch',
//         method: 'post',
//         data
//     })
// }
export function workOrderDispatch(data) {
    return request({
        url: process.env.VUE_APP_MT_API + '/workOrder/dispatchOrder',
        method: 'post',
        data
    })
}

// 派工单详情（维修队查看）
export function teamOrgNodeId(id, teamOrgNodeId) {
    return request({
        url: process.env.VUE_APP_MT_API + `/WorkOrder/teamOrgOrder?id=${id}&teamOrgNodeId=${teamOrgNodeId}`,
        method: 'get'
    })
}

// 生成返修结算单
export function statementRepair(data) {
    return request({
        url: process.env.VUE_APP_MT_API + '/statement/repair',
        method: 'post',
        data
    })
}
// 关闭派工单
export function WorkOrderclose(id) {
    return request({
        url: process.env.VUE_APP_MT_API + `/WorkOrder/close/` + id,
        method: 'get'
    })
}
// 工位档案列表
export function StationWorkList(data) {
    return request({
        url: process.env.VUE_APP_REPORT_API + '/StationWork/listWorker',
        method: 'post',
        data
    })
}
